import { Hierarchy } from '~/types';
import {
  AUM,
  ComputedMasterRow,
} from '~/components/ui/tables/ag/documentsGroupTable/types';
import { formatMultiCurrency } from '~/lib/money';

export function hierarchyComputeMasterRow(hierarchyResponses: Hierarchy[]) {
  const res: ComputedMasterRow[] = [];
  hierarchyResponses.forEach((hierarchyResponse) => {
    const AUMValues: AUM = {};
    let fundCount = 0;
    const { legalJurisdiction, funds } = hierarchyResponse;
    funds.forEach((fund) => {
      fundCount++;
      AUMValues[fund.currency] = (AUMValues[fund.currency] ?? 0) + fund.size;
    });
    const aumTotals = formatMultiCurrency(AUMValues);
    const computedMasterRow: ComputedMasterRow = {
      jurisdiction: legalJurisdiction,
      aumTotals,
      funds: funds.map((fund) => ({
        ...fund,
        jurisdictionName: legalJurisdiction.name,
      })),
      fundCount,
    };
    res.push(computedMasterRow);
  });
  return res;
}
